<!-- Full Width Container -->
<div class="py-8">

	<!-- Centered Content Box -->
	<div class="pixel-9-slice">
		<div class="max-w-4xl mx-auto bg-base-100 p-8 min-h-[600px] sm:pb-[0px] pb-[170px]">

			<!-- Loading State -->
			@if (isValidatingCode()) {
			<div>
				<h2>Validating Reset Code</h2>
				<p class="text-base-content/60 text-xs mt-2">Please wait while we verify your reset link...</p>
			</div>
			}

			<!-- Invalid Code State -->
			@if (!isValidatingCode() && !isCodeValid()) {
			<div class="flex flex-col gap-4 mb-4 items-start">
				<h2>Invalid Reset Link</h2>
				<p class="text-base-content/60 text-xs mt-2 mb-6">This password reset link is invalid or has expired.
				</p>


				<button (click)="goToForgotPassword()" class="red-cta-btn-xlg retro-pixel-regular mb-4">
					TRY AGAIN
				</button>
				<button (click)="goToLogin()" class="yellow-cta-btn-xlg retro-pixel-regular">
					BACK TO SIGN IN
				</button>

			</div>
			}

			<!-- Valid Code - Reset Form -->
			@if (!isValidatingCode() && isCodeValid()) {
			<!-- Reset Your Password Header -->
			<div>
				<h2>RESET PASSWORD</h2>
				<p class="text-base-content/60 text-xs mt-2 mb-8">Enter your new password for {{ email() }}</p>
			</div>

			<!-- Error Message -->
			@if (errorMessage()) {
			<div class="bg-error/10 border border-error text-error p-3 rounded mb-4">
				{{ errorMessage() }}
			</div>
			}

			<!-- Success Message -->
			@if (successMessage()) {
			<div class="bg-success/10 border border-success text-success p-3 rounded mb-4">
				{{ successMessage() }}
			</div>
			}

			<!-- Reset Password Form -->
			<form (ngSubmit)="onSubmit()" #resetPasswordForm="ngForm">
				<!-- New Password Field -->
				<div class="mb-5">
					<label for="newPassword" class="block mb-1.5 text-base-content font-medium">New Password</label>
					<div class="relative">
						<input [type]="showPassword() ? 'text' : 'password'" id="newPassword" name="newPassword"
							[(ngModel)]="newPassword" required minlength="6" class="w-full p-3 pr-12 border-2 rounded"
							[class.border-error]="resetPasswordForm.form.get('newPassword')?.invalid && resetPasswordForm.form.get('newPassword')?.touched"
							[class.border-base-300]="!(resetPasswordForm.form.get('newPassword')?.invalid && resetPasswordForm.form.get('newPassword')?.touched)"
							placeholder="Enter password"
							(blur)="resetPasswordForm.form.get('newPassword')?.markAsTouched()">
						<button type="button" (click)="togglePasswordVisibility()"
							class="absolute right-3 top-1/2 transform -translate-y-1/2 bg-transparent border-none cursor-pointer text-base-content/60 p-0">
							@if (showPassword()) {
							<eye-slash-icon [color]="'currentColor'" [size]="20"></eye-slash-icon>
							} @else {
							<eye-icon [color]="'currentColor'" [size]="20"></eye-icon>
							}
						</button>
					</div>
					<p class="mt-3 mx-2 text-base-content/50 text-xs">Must be at least 6 characters long.</p>
				</div>

				<!-- Confirm Password Field -->
				<div class="mb-6">
					<label for="confirmPassword" class="block mb-1.5 text-base-content font-medium">Confirm New
						Password</label>
					<div class="relative">
						<input [type]="showConfirmPassword() ? 'text' : 'password'" id="confirmPassword"
							name="confirmPassword" [(ngModel)]="confirmPassword" required
							class="w-full p-3 pr-12 border-2 rounded"
							[class.border-error]="resetPasswordForm.form.get('confirmPassword')?.invalid && resetPasswordForm.form.get('confirmPassword')?.touched"
							[class.border-base-300]="!(resetPasswordForm.form.get('confirmPassword')?.invalid && resetPasswordForm.form.get('confirmPassword')?.touched)"
							placeholder="Confirm password"
							(blur)="resetPasswordForm.form.get('confirmPassword')?.markAsTouched()">
						<button type="button" (click)="toggleConfirmPasswordVisibility()"
							class="absolute right-3 top-1/2 transform -translate-y-1/2 bg-transparent border-none cursor-pointer text-base-content/60 p-0">
							@if (showConfirmPassword()) {
							<eye-slash-icon [color]="'currentColor'" [size]="20"></eye-slash-icon>
							} @else {
							<eye-icon [color]="'currentColor'" [size]="20"></eye-icon>
							}
						</button>
					</div>
				</div>

				<!-- Submit Button -->
				<button type="submit" [disabled]="isLoading() || resetPasswordForm.form.invalid"
					class="red-cta-btn-xlg retro-pixel-regular mb-5">
					@if (isLoading()) {
					<span>RESETTING</span>
					} @else {
					<span>RESET</span>
					}
				</button>
			</form>

			<!-- Links -->
			<div class="flex flex-col gap-2 mb-4 items-start">
				<button type="button" (click)="goToLogin()"
					class="bg-transparent border-none text-primary cursor-pointer text-sm">
					Back to Login
				</button>
			</div>
			}

		</div>
	</div>

	<!-- Overlaid Crustopher -->
	<div class="crustopher-overlay">
		<img [src]="avatarImage()" alt="Crustopher Avatar" class="crustopher-image" (click)="onAvatarClick()">
	</div>

</div>